import axios from 'axios'
import Router from '../router';
import Store from '../store'

let apiIoffice = process.env.VUE_APP_IOFFICE_API;
let apiUpload = process.env.VUE_APP_FILE_API;


export const DataApi = axios.create({
    baseURL: apiIoffice,
});
export const DataApiRTA = axios.create({
    baseURL: apiIoffice,
});
export const DataApiUpload = axios.create({
    baseURL: apiUpload
});


DataApi.interceptors.request.use(
    config => {
        config.headers.Authorization = 'Bearer ' + localStorage.getItem("token");
        return config;
    },
    error => Promise.reject(error)
);
DataApiRTA.interceptors.request.use(
    config => {
        config.headers.Authorization = 'Bearer ' + localStorage.getItem("tokenRTA");
        return config;
    },
    error => Promise.reject(error)
);
DataApiUpload.interceptors.request.use(
    config => {
        config.headers.Authorization = 'Bearer ' + localStorage.getItem("token");
        return config;
    },
    error => Promise.reject(error)
);
/**
 * Load
 */
DataApi.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response.status === 401) {
            Store.state.messageAuth = true
            localStorage.removeItem("token");
            Router.push('/pages/login')
        }
        if (error.response.status === 500) {
            alert(error.response.data.message);
        }
        Promise.reject(error);
    }
);
DataApiRTA.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response.status === 401) {
            alert(error.response.data.message);
        }
        if (error.response.status === 500) {
            alert(error.response.data.message);
        }
        Promise.reject(error);
    }
);
DataApiUpload.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response.status === 401) {
            localStorage.removeItem("token");
            location.replace('/');
        }
        if (error.response.status === 500) {
            alert(error.response.data.message);
        }
        Promise.reject(error);
    }
);